export const SECONDARY_NAVIGATION_TEST_IDS = {
  actions: 'secondary-navigation__actions',
  root: 'secondary-navigation',
  skeleton: 'secondary-navigation__skeleton',
  status: 'secondary-navigation__status',
  tab: (value: string) => `secondary-navigation__tab-${value}`,
  title: 'secondary-navigation__title',
  titleAccessory: 'secondary-navigation__title-accessory',
} as const;
